import { useAuth } from '@/contexts/AuthContext';
import { supabase } from '@/integrations/supabase/client';
import { useQuery } from '@tanstack/react-query';
import { Card, CardContent } from '@/components/ui/card';
import { InternalTaskBoard } from './InternalTaskBoard';
import { CampaignManager } from './CampaignManager';
import { ListTodo, CheckCircle, Megaphone, TrendingUp } from 'lucide-react';

export function MarketingMemberDashboard() {
  const { user } = useAuth();

  const { data: myTeam } = useQuery({
    queryKey: ['my-marketing-team', user?.id],
    queryFn: async () => {
      if (!user) return null;
      const { data } = await supabase.from('internal_team_members').select('team_id').eq('user_id', user.id).limit(1).maybeSingle();
      return data;
    },
    enabled: !!user,
  });

  const { data: stats } = useQuery({
    queryKey: ['marketing-member-stats', user?.id],
    queryFn: async () => {
      if (!user) return { activeTasks: 0, completedTasks: 0, campaigns: 0 };
      const [tasks, campaigns] = await Promise.all([
        supabase.from('internal_tasks').select('status').eq('assigned_to', user.id),
        supabase.from('marketing_campaigns').select('*', { count: 'exact', head: true }).eq('created_by', user.id),
      ]);
      const taskData = tasks.data || [];
      return {
        activeTasks: taskData.filter((t: any) => t.status !== 'done' && t.status !== 'cancelled').length,
        completedTasks: taskData.filter((t: any) => t.status === 'done').length,
        campaigns: campaigns.count || 0,
      };
    },
    enabled: !!user,
  });

  return (
    <div className="space-y-6">
      <div>
        <h2 className="text-2xl font-bold">Marketing Dashboard</h2>
        <p className="text-muted-foreground">Your tasks and campaigns</p>
      </div>

      <div className="grid grid-cols-2 md:grid-cols-3 gap-4">
        <Card><CardContent className="p-4 flex items-center gap-3"><ListTodo className="h-8 w-8 text-blue-500" /><div><p className="text-2xl font-bold">{stats?.activeTasks || 0}</p><p className="text-xs text-muted-foreground">Active Tasks</p></div></CardContent></Card>
        <Card><CardContent className="p-4 flex items-center gap-3"><CheckCircle className="h-8 w-8 text-green-500" /><div><p className="text-2xl font-bold">{stats?.completedTasks || 0}</p><p className="text-xs text-muted-foreground">Tasks Done</p></div></CardContent></Card>
        <Card><CardContent className="p-4 flex items-center gap-3"><Megaphone className="h-8 w-8 text-primary" /><div><p className="text-2xl font-bold">{stats?.campaigns || 0}</p><p className="text-xs text-muted-foreground">My Campaigns</p></div></CardContent></Card>
      </div>

      <InternalTaskBoard teamId={myTeam?.team_id} assignedToMe />
      <CampaignManager teamId={myTeam?.team_id} />
    </div>
  );
}
